const getAuthentification = () => {
    var data = localStorage.getItem("user")
    if (data == null) {
        window.location.href = '/bad-request'
    }
}

export default getAuthentification;
